/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomePageComponent} from './home-page.component';

@NgModule({
    declarations: [HomePageComponent],
    imports: [
        CommonModule
    ]
})
export class HomePageModule {
}
